module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/AOGRWH/tc-custom/9781609254261.jpg?1713478120618",
      "alt": "This image is the cover for the book Esoteric Magic and the Cabala"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Esoteric Magic and the Cabala\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A manual for developing inner-guidance and concentration through meditations and rituals for the practice of high magic.")]), _c('br'), _c('br'), _vm._v("The study of magic is divided into two distinct disciplines: practical and esoteric. Practical magic uses the power of the mind to attain physical results such as more money, a bigger house, better health. Esoteric magic, the subject of Phillip Cooper’s new book, focuses on the quest for greater understanding and mental discipline. Its aims are the discovery of inner truths and the understanding of the workings of creation."), _c('br'), _c('br'), _vm._v("In his typical no-nonsense manner, Cooper conveys the principles of esoteric magic and offers a positive, realistic means of studying and understanding magic on a deeply personal level. Esoteric Magic and the Cabala helps readers train their minds, their emotions, and their imaginations to more fully understand reality."), _c('br'), _c('br'), _c('i', [_vm._v("Esoteric Magic and the Cabala")]), _vm._v(" is both positive and realistic. It helps readers learn to use the Tree of Life as a means of classifying knowledge, of observing an interrelated whole, a method that provides the tools for endless self-discovery. It offers a complete, workable plan of study that novices will find easy to understand and advanced practitioners will find refreshing and stimulating after the usual confusing and dogmatic magic texts.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Phillip Cooper\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Weiser Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0